import {
  intersectionWatcher,
  delayOffset,
  shouldAnimate,
} from "@/lib/animation";
import { qsa } from "@fluorescent/dom";

const selectors = {
  quote: ".quote__item",
};

export default node => {
  if (!shouldAnimate(node)) return;

  const quotes = qsa(selectors.quote, node);

  quotes.forEach(quote => delayOffset(quote, [":scope > *"]));

  const observer = intersectionWatcher(node, true);

  return {
    destroy() {
      observer?.destroy();
    },
  };
};
